import { Problem, LessonProblem, ProblemAnswer } from '@yandex-int/k-common/typings';

interface ProblemWithAttempt extends Problem {
    attempt: ProblemAnswer;
    custom_answers: any[];
}

export interface LessonProblemWithResult extends LessonProblem {
    problem: ProblemWithAttempt;
}

export enum PROBLEM_DISPLAY_STATUS {
    SEEN = 'seen',
    NOT_SEEN = 'notSeen',
    CORRECT = 'correct',
    INCORRECT = 'incorrect',
    SOLVED = 'solved',
    NOT_SOLVED = 'notSolved',
}

export interface LessonRunResult {
    correctNumber: number;
    incorrectNumber: number;
    maxPoints?: number;
    points?: number;
    problemsNumber: number;
}
